module.exports = __webpack_public_path__ + "static/media/Bill Buxton.5c9a5529.png";